<template>
    <div class="home">
        <Header ref="height0" :seachIptGray="true"  />
        <div class="list-container">
            <div class="list-item"   @click="disPage(item)" v-for="(item, index) in items" :key="index">
                <div class="text-content">
                    <h3 class="item-title __line1">{{ item.title }}</h3>
                    <p class="item-description __line1" v-html="item.title_en"></p>
                </div>
                <img :src="item.banner" alt="Item Image" class="item-image" />
                <img class="mask2" src="@/assets/images/mask2.png" alt="" srcset="">
            </div>
        </div>
        <div style="width:100%;height:84px"></div>
        <tabBar></tabBar>
    </div>
</template>
      
<script>
import { Toast } from "vant";
import Crypt from "@bluedot-tech/vue-ui/es/utils/crypt";
import config from "../config/config";
import Header from "@/components/header";
import tabBar from "@/components/tabBar.vue";
export default {
    components: {
        Header,
        tabBar
    },
    data() {
        return {
            items: [
            ],

        };
    },
    mounted() {
        this.query = this.$route.query;
        this.initShare();
        // 页面浏览 监测
        this.$dataStatistics({
            page_title: `解决方案`,
        },'访问');
        this.getNavList();
    
    },

    methods: {
        disPage(item) {
            this.$dataStatistics('click', '查看解决方案');
            this.$router.push(`/solutionDis?id=${item.id}`)
        },

     

        getNavList() {
            let params = {
                'filter[title]': '',
            }
            this.$http
                .get('/api/platform/area', { params: params })
                .then((res) => {
                  this.items = res.data.data;
                });
        },

    },
};
</script>
<style lang="less" scoped>
.home{
    min-height: 100vh;
    background: #FAFAFA;
}
.list-container {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    margin-top: 20px;
    padding: 0 12px;
    /* 项目之间的间距 */
}

.list-item {
    width: calc(50% - 6px);
    /* 减去间距的一半 */
    box-sizing: border-box;
    padding: 10px 12px;
    height: 92px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
    border-radius: 8px 8px 8px 8px;
    background-size: 100% 100%;
}

.text-content {
    z-index: 2;
    position: absolute;
    top: 0;
    bottom: 0;
    margin: 0;
    left: 12px;
    display: flex;
   justify-content: center;
    flex-flow: column;
    /* 图片与文字之间的间距 */
}

.item-title {
    font-size: 16px;
    color: #ffffff;
    line-height: 24px;
}

.item-description {
    font-size: 12px;
    color: #ffffff;
    line-height: 18px;
    white-space: pre;
    text-align: left;
}

.item-image {
  width: 100%;
  height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    object-fit: cover;
    border-radius: 8px 8px 8px 8px;
}
.mask2{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  height: 100%;
  border-radius: 8px 8px 8px 8px;
}
</style>
      